import Switch from 'react-bootstrap-switch';

import { SWITCH_BS_SIZES, SWITCH_COLORS } from './SwitchConstants';

Switch.SWITCH_BS_SIZES = SWITCH_BS_SIZES;
Switch.SWITCH_COLORS = SWITCH_COLORS;

export default Switch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Switch/Switch.js
// module id = 756
// module chunks = 0